import React, { useState, useEffect } from 'react';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    Divider,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    InputAdornment,
    MenuItem,
    Grid
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import { connect } from "react-redux";
import DateFnsUtils from '@date-io/date-fns';
import * as logger from '../../../logger';
import { getTripDateFilterValues, numberWithCommas, replaceCommas, checkNumberOnly } from '../../../utils/utils';
import { markDoneCss as useStyles } from './VehicleDialogCss';
import { DeletePhotoAttachments, updateVehicle3, singleTruck, PandL, Expenses } from '../../../store/actions/vehicleActionCreator';
import { addVendorExpense } from "../../../store/actions/tripActionCreator";
import AddAlertIcon from '@material-ui/icons/AddAlert';
import NotesIcon from '@material-ui/icons/Notes';
import S3Uploader from '../s3Uploader/s3Uploader';
import DriverNameSelect from '../DriverDialogs/DriverNameSelect';
import AmountInput from '../Inputs/AmountInput';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';

const MarkDoneDialog = ({ open, onClose, dispacthAddExpenses, dispatchUpdateVehicleNew, dispatchGetSingleTruck, dispatchGetTripExpenses, dispatchGetPandL, dispatchPhotoAttachmentDelete, vehicle, onConfirm, upcomingData, user }) => {

    let submit;
    const [dialogOpen, setDialogOpen] = useState(open);
    const [remindMeValue, setRemindMeValue] = useState(false);
    const [addExpensePhoto, setAddExpensePhoto] = useState([]);
    const [paidByDriverValue, setPaidByDriverValue] = useState(false);
    const [addDriverDialog, setAddDriverDialog] = useState(false);
    const [amountValue, setAmountValue] = useState("");

    const [reminderDuration, setReminderDuration] = useState("");
    const [reminderDurationUnit, setReminderDurationUnit] = useState("");
    const [reminderConfigValue, setReminderConfigValue] = useState([]);

    const classes = useStyles();

    useEffect(() => {
        setReminderConfigValue(vehicle.maintenanceConfig);
    }, [vehicle.maintenanceConfig]);

    let singleTruck = vehicle.singleTruck;

    const initialValues = {
        amount: amountValue ? amountValue : "",
        expenseDate: new Date(),
        remindMe: remindMeValue,
        reminderValue: "3 months",
        notes: "",
        paidByDriver: paidByDriverValue
    };

    const validate = values => {

        const errors = {}

        if (!values.amount || !checkNumberOnly(replaceCommas(values.amount))) {
            errors.amount = "Please enter valid amount."
        }

        return errors;

    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleDeleteExpensePhoto = (index, attachId) => {

        var newPhoto = [...addExpensePhoto];
        newPhoto.splice(index, 1);
        setAddExpensePhoto(newPhoto);

    }

    const handlePaidByDriver = (value) => {

        setPaidByDriverValue(!paidByDriverValue);

        if (singleTruck.driverName == null) {
            setAddDriverDialog(true);
        }
    }

    const handleAddExpensePhoto = (file) => {
        var newPhoto = [...addExpensePhoto];
        newPhoto.push({ s3Link: file });
        setAddExpensePhoto(newPhoto);
    }

    const handleAddDriverDialogClose = () => {
        setAddDriverDialog(false);
        setPaidByDriverValue(false);
    }

    const handleAddDriverSubmit = (driverIdValue) => {

        let vehicleIdValue = singleTruck.id;

        var data = {
            driverId: driverIdValue
        }

        var dateFilterValueUtil = getTripDateFilterValues();

        var startDateRange = dateFilterValueUtil["ALL_MONTHS"].startDateRange;

        var PandLdata = {
            vehicleId: vehicleIdValue,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        var expenseData = {
            vehicleId: vehicleIdValue,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseParentType: []
        };

        let defaultDateFilterValue = "ALL_MONTHS";
        let defaultTripBookFilterValue = "All Trips & Expenses";

        dispatchUpdateVehicleNew(
            vehicleIdValue,
            data,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Add Driver Dialog", "Update Vehicle successfull");
                    setAddDriverDialog(false);
                    dispatchGetSingleTruck(vehicleIdValue,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Successfull ");
                                dispatchGetPandL(PandLdata, defaultDateFilterValue,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log("Single Vehicle Component Dweb", "Get P and L report Successfull");
                                            dispatchGetTripExpenses(expenseData, defaultTripBookFilterValue,
                                                (data) => {
                                                    if (data && data.status && data.status.code == 200) {
                                                        logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Successfull");
                                                    }
                                                },
                                                () => {
                                                    logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Failed");
                                                },
                                            )
                                        }
                                    },
                                    () => {
                                        logger.log("Single Vehicle Component Dweb", "Get P and L report Failed");
                                    },
                                )
                            }
                        },
                        () => {
                            logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Failed");
                        }
                    );
                }
            },
            () => {
                logger.log("Add Driver Dialog", "Update Vehicle failed");
            }
        );
    }

    const onSubmit = values => {

        let attach = [];

        addExpensePhoto.map((link) => {
            if (typeof (link) === 'object') {
                attach.push({ s3Link: link.s3Link, id: link.id });
            } else {
                attach.push({ s3Link: link });
            }
        })

        const fleetOwnerIdValue = user.userInfo.entityId;

        let expenseData = {
            vehicleId: singleTruck && singleTruck.id ? singleTruck.id : "",
            fleetOwnerId: fleetOwnerIdValue,
            amount: replaceCommas(values.amount),
            expenseDate: Math.round((values.expenseDate.setHours(0, 0, 0, 0) / 1000)),
            expenseType: upcomingData && upcomingData.expenseType ? upcomingData.expenseType : "",
            description: values.notes,
            kmReading: values.kmReading,
            attachments: attach,
            expenseParentType: "maintenance",
            paidByDriver: values.paidByDriver
        }

        if (values.remindMe) {

            let index = reminderConfigValue.findIndex(x => x.display == values.reminderValue);
            let reminderType = reminderConfigValue[index].value;

            expenseData.is_reminder_enabled = 1;
            expenseData.reminder_duration = Number(reminderType.count);
            expenseData.reminder_duration_unit = reminderType.unit;
        } else {
            expenseData.is_reminder_enabled = 0;
        }

        dispacthAddExpenses(expenseData,
            (data) => {
                if (data.status && data.status.code == 200) {
                    logger.log("Maintenance Book", "Add expense successfull");
                    onConfirm();
                }
            },
            () => {
                logger.log("Maintenance Book", "Add expense failed");
            }
        );

    }

    const handleRemindMeValue = () => {
        setRemindMeValue(!remindMeValue);
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Amount Paid</div>
                            <AmountInput
                                placeholder="Amount Paid"
                                name="amount"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setAmountValue(e.target.value)}
                                fieldProps={{
                                    // parse: value => value && numberWithCommas(value)
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                                }}
                                className={classes.marginV1}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Expense Date</div>
                            <DatePicker
                                disableFuture
                                name="expenseDate"
                                margin="none"
                                variant="inline"
                                fullWidth={true}
                                // onChange={(date) => { setTripStartDate(date) }}
                                inputVariant="outlined"
                                size="small"
                                format="dd-MM-yyyy"
                                placeholder="Select Date"
                                dateFunsUtils={DateFnsUtils}
                                className={classes.marginV1}
                                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                            />
                        </div>
                    </>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.divV7}>
                        <div className={classes.divV8}>
                            <AddAlertIcon />
                            <div>Remind me</div>
                            {remindMeValue &&
                                <>
                                    <div className={classes.divV9}>after</div>
                                    {reminderConfigValue && reminderConfigValue.length > 0 &&
                                        <Select
                                            name="reminderValue"
                                            variant="outlined"
                                            //label={''}
                                            notched
                                            labelWidth={0}
                                            placeholder={''}
                                            formControlProps={{ margin: 'none', size: "small", fullWidth: false, labelWidth: 0 }}
                                            className={classes.selectV1}
                                        >
                                            {reminderConfigValue && reminderConfigValue.length > 0 && reminderConfigValue.map((type, index) => {
                                                return (<MenuItem key={index} value={type.display}>{type.display}</MenuItem>);
                                            })}
                                        </Select>
                                    }
                                </>
                            }
                        </div>
                        <Switches
                            size='small'
                            margin='normal'
                            formControlProps={{
                                className: classes.switchControl
                            }}
                            onChange={(e, value) => { handleRemindMeValue() }}
                            className={classes.switch}
                            name="remindMe"
                            data={{ label: '', value: true }} label="" />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <div className={classes.title}>Current KM Reading</div>
                        <TextField
                            placeholder="KM Reading"
                            name="kmReading"
                            variant="outlined"
                            size="small"
                            className={classes.marginV1}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">KMs</InputAdornment>
                            }}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <div className={classes.title}>Notes</div>
                        <TextField
                            placeholder="Notes"
                            name="notes"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            multiline={true}
                            rows={3}
                            rowsMax={3}
                            className={classes.textNote}
                            InputProps={{
                                startAdornment: <InputAdornment position="start" className={classes.inputAdornmentV1}> <NotesIcon /></InputAdornment>
                            }}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                        >
                            {addExpensePhoto && addExpensePhoto.length > 0 &&
                                <Grid item>
                                    <div className="S3Uploader-image-margin">
                                        {addExpensePhoto && addExpensePhoto.map((expenseImage, index) => (
                                            <div className="S3Uploader-image-div">
                                                {expenseImage.s3Link && <img className="S3Uploader-imagesrc" src={expenseImage.s3Link} alt="fileUpload" />}
                                                <img className="S3Uploader-imageclose" src={require("../../../assets/close-icon.svg")} onClick={() => { handleDeleteExpensePhoto(index, expenseImage.id) }}></img>
                                            </div>
                                        ))}
                                    </div>
                                </Grid>}
                            <Grid item>
                                <S3Uploader toggle={true} directoryName={"dweb-images/Trip/SettleAmount"} handleFile={handleAddExpensePhoto} />
                            </Grid>
                        </Grid>
                    </div>

                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.divV4}>
                        <div className={classes.divV5}>Paid by {singleTruck && singleTruck.driverName ? singleTruck.driverName : 'Driver'}</div>
                        <Switches
                            size='small'
                            margin='normal'
                            formControlProps={{
                                className: classes.switchControl
                            }}
                            // formGroupProps={{}}
                            // formControlLabelProps={{
                            //     classes: {
                            //         root: formClasses.switchLabel
                            //     },
                            // }}
                            onChange={() => { handlePaidByDriver() }}
                            className={classes.switch}
                            name="paidByDriver"
                            data={{ label: '', value: true }} label="" />
                    </div>
                ),
            }
        ]
    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='sm'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paper: classes.paper2, paperWidthSm: classes.paperWidth }}>
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divV1}>Mark Done</div>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <Divider />
                <DialogContent>
                    <div className={classes.divBox}>
                        <div className={classes.color1}>
                            Expense Type
                        </div>
                        <div className={classes.divExpenseType}>
                            {upcomingData && upcomingData.expenseName ? upcomingData.expenseName : ""}
                        </div>
                    </div>

                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>
                <Divider className={classes.marginV3} />
                <DialogActions className={classes.da1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button className={classes.confirmV1} type="submit" variant="contained"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            {addDriverDialog && <DriverNameSelect onOpen={addDriverDialog} onClose={handleAddDriverDialogClose} fromSingleTruck={true} onConfirm={handleAddDriverSubmit} />}
        </>
    )

}

const mapStateToProps = (state) => ({ vehicle: state.vehicle, user: state.user });
const mapDispatchToProps = (dispatch) => ({
    dispatchPhotoAttachmentDelete: (expenseId, attachId, onSuccess, onFailure) => dispatch(DeletePhotoAttachments(expenseId, attachId, onSuccess, onFailure)),
    dispatchUpdateVehicleNew: (vehicleId, data, onSuccess, onFailure) => {
        dispatch(
            updateVehicle3(vehicleId, data, onSuccess, onFailure))
    },
    dispacthAddExpenses: (data, onSuccess, onFailure) => dispatch(addVendorExpense(data, onSuccess, onFailure)),
    dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
    dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure)),
    dispatchGetSingleTruck: (truckId, onSuccess, onFailure) => dispatch(singleTruck(truckId, onSuccess, onFailure)),
});

export default (connect)(mapStateToProps, mapDispatchToProps)(MarkDoneDialog);